module.exports = __webpack_public_path__ + "img/payment_logos.68bc84a9.svg";